// extracted by mini-css-extract-plugin
export var animationContainer = "_bc-0";
export var asteriskIcon = "_bc-8";
export var conversationLeftSection = "_bc-4";
export var conversationListItem = "_bc-3";
export var conversationMiddleSection = "_bc-5";
export var conversationRightSection = "_bc-6";
export var detailsContent = "_bc-1";
export var listContainer = "_bc-7";
export var modalContent = "_bc-2";